import { DateTime } from 'luxon';
import { SupportedPublicLocale } from './types';

/**
 * Formats an ISO 8601 date string to a locale-aware date/time string.
 * Automatically converts to the user's local timezone.
 *
 * @param isoString - ISO 8601 date string (e.g., "2026-01-24T14:18:00Z")
 * @param locale - The locale to use for formatting ('en' or 'fr')
 * @returns Formatted date string (e.g., "Jan 24, 2026, 2:18 PM" or "24 janv. 2026, 14:18")
 */
export function formatCompletionDate(isoString: string, locale: SupportedPublicLocale): string {
  const dt = DateTime.fromISO(isoString);

  if (!dt.isValid) {
    return locale === 'fr' ? 'Date invalide' : 'Invalid date';
  }

  // Use locale-appropriate format
  // en-CA and fr-CA provide clean North American formatting
  const localeCode = locale === 'fr' ? 'fr-CA' : 'en-CA';

  return dt.setLocale(localeCode).toLocaleString(DateTime.DATETIME_MED);
}
